import * as yup from 'yup';

export const costoAdministrativoFormSchema = yup.object({
  nombre: yup.string().required('El campo nombre es requerido'),
  valor: yup.string().required('El campo valor es requerido'),
  estado: yup
    .boolean()
    .typeError('El campo estado es requerido')
    .required('El campo estado es requerido'),
});
